var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('layout-report-step', {
    attrs: {
      "isDone": _vm.isDone,
      "title": _vm.header.title,
      "description": _vm.header.description,
      "image": _vm.header.image,
      "debug": _vm.header.debug
    }
  }, [_c('v-card', {
    staticClass: "pt-4 pr-4 pl-4",
    attrs: {
      "flat": "",
      "max-width": "500"
    }
  }, [_c('v-form', {
    ref: "form",
    model: {
      value: _vm.valid,
      callback: function callback($$v) {
        _vm.valid = $$v;
      },
      expression: "valid"
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.tripTypeOptions,
      "rules": _vm.requiredRule,
      "outlined": "",
      "label": _vm.$t('report.tripDetails.purpose'),
      "data-test-trip-purpose": ""
    },
    model: {
      value: _vm.tripType,
      callback: function callback($$v) {
        _vm.tripType = $$v;
      },
      expression: "tripType"
    }
  }), _c('v-radio-group', {
    attrs: {
      "label": _vm.$t('report.tripDetails.isValidDriversLicense'),
      "data-test-valid-license": ""
    },
    model: {
      value: _vm.isValidDriversLicense,
      callback: function callback($$v) {
        _vm.isValidDriversLicense = $$v;
      },
      expression: "isValidDriversLicense"
    }
  }, [_c('v-radio', {
    attrs: {
      "label": _vm.$t('yes'),
      "value": true,
      "color": "primary"
    }
  }), _c('v-radio', {
    attrs: {
      "label": _vm.$t('no'),
      "value": false,
      "color": "primary"
    }
  })], 1), _c('v-radio-group', {
    attrs: {
      "label": _vm.$t('report.tripDetails.isUnderInfluence'),
      "data-test-is-under-influence": ""
    },
    model: {
      value: _vm.isUnderInfluence,
      callback: function callback($$v) {
        _vm.isUnderInfluence = $$v;
      },
      expression: "isUnderInfluence"
    }
  }, [_c('v-radio', {
    attrs: {
      "label": _vm.$t('yes'),
      "value": true,
      "color": "primary"
    }
  }), _c('v-radio', {
    attrs: {
      "label": _vm.$t('no'),
      "value": false,
      "color": "primary"
    }
  })], 1)], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }